<template>
    <div class="dt-gift-voucher-status">
        <div class="cash-labels">
            <!-- Voucher Status -->
            <div class="alert cash-label"
                 :class="[soldGiftVoucher.isRedeemable ? 'alert-success' : 'alert-danger']">
                <h4>{{ l('SEARCH_MODAL.STATUS') }}</h4>

                <template v-if="soldGiftVoucher.redeemableStatus === SoldGiftVoucherRedeemableStatus.REDEEMABLE">
                    <div>
                        <span class="indicator block indicator-success">
                            {{ l('SEARCH_MODAL.STATUS_REDEEMABLE') }}
                        </span>
                    </div>
                    <small>
                        {{ l('SEARCH_MODAL.EXPIRES_DATE') }}
                        {{ dateFilter(soldGiftVoucher.expiresAt) }}
                    </small>
                </template>

                <template v-if="soldGiftVoucher.redeemableStatus === SoldGiftVoucherRedeemableStatus.REDEEMED">
                    <div>
                        <span class="indicator block indicator-danger">
                            {{ l('SEARCH_MODAL.STATUS_REDEEMED') }}
                        </span>
                    </div>
                    <small>
                        {{ l('SEARCH_MODAL.REDEEMED_DATE') }}
                        {{ dateFilter(soldGiftVoucher.redeemedAt) }}
                    </small>
                </template>

                <template v-if="soldGiftVoucher.redeemableStatus === SoldGiftVoucherRedeemableStatus.EXPIRED">
                    <div>
                        <span class="indicator block indicator-danger">
                            {{ l('SEARCH_MODAL.STATUS_EXPIRED') }}
                        </span>
                    </div>
                    <small>
                        {{ l('SEARCH_MODAL.EXPIRED_DATE') }}
                        {{ dateFilter(soldGiftVoucher.expiresAt) }}
                    </small>
                </template>

                <template v-if="soldGiftVoucher.redeemableStatus === SoldGiftVoucherRedeemableStatus.INACTIVE">
                    <div>
                        <span class="indicator block indicator-danger">
                            {{ l('SEARCH_MODAL.STATUS_INACTIVE') }}
                        </span>
                    </div>
                </template>

                <template v-if="soldGiftVoucher.redeemableStatus === SoldGiftVoucherRedeemableStatus.UNSUPPORTED">
                    <div class="indicator block indicator-danger">
                        {{ l('SEARCH_MODAL.STATUS_UNSUPPORTED') }}
                    </div>
                </template>

                <template v-if="soldGiftVoucher.redeemableStatus === SoldGiftVoucherRedeemableStatus.VOUCHER_DELETED">
                    <div class="indicator block indicator-danger">
                        {{ l('SEARCH_MODAL.STATUS_VOUCHER_DELETED') }}
                    </div>
                </template>
            </div>

            <!-- Voucher Type -->
            <div class="alert alert-info cash-label">
                <h4>{{ soldGiftVoucher.giftVoucher.giftVoucherType }} {{ l('GIFT_VOUCHERS.VOUCHER') }}</h4>

                <h3>{{ soldGiftVoucher.giftVoucher.name }}</h3>
            </div>

            <!-- Remaining Balance -->
            <div v-if="soldGiftVoucher.giftVoucher.giftVoucherType === 'Balance'"
                 class="alert alert-info cash-label">
                <h4>{{ l('SEARCH_MODAL.REMAINING_BALANCE') }}</h4>

                <h3>{{ currencyFilter(soldGiftVoucher.currentBalance) }}</h3>

                <small>
                    {{ l('SEARCH_MODAL.ORIGINAL_BALANCE') }}
                    {{ currencyFilter(soldGiftVoucher.initialBalance) }}
                </small>
            </div>
        </div>
    </div>
</template>

<script>
import SoldGiftVoucherRedeemableStatus from '@/lib/GiftVouchers/SoldGiftVoucherRedeemableStatus';

export default {
    name: 'DtGiftVoucherStatus',

    props: {
        soldGiftVoucher: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            SoldGiftVoucherRedeemableStatus,
        };
    },
};
</script>
